(() => {
  const init = () => {
    const videos = Array.from(document.querySelectorAll('video[data-fs-video-autoplay]'));
    if (!videos.length) {
      return; 
    }

    const designMode = Boolean(window.Shopify && Shopify.designMode);
    const prefersReducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const prefersReducedMotion = () => prefersReducedMotionQuery.matches;
    const supportsIntersectionObserver = 'IntersectionObserver' in window;

    const desktopMediaQuery = window.matchMedia('(min-width: 901px)');

    const canPlayOnCurrentViewport = (video) => {
      if (prefersReducedMotion()) {
        return false;
      }
      const mobileEnabled = video.dataset.fsMobileVideoEnabled === 'true';
      if (desktopMediaQuery.matches || designMode) {
        return true;
      }
      return mobileEnabled;
    };

    const loadVideoSource = (video) => {
      if (video.dataset.fsVideoLoaded === 'true') {
        return;
      }

      if (!canPlayOnCurrentViewport(video)) {
        return;
      }

      const source = video.querySelector('source[data-src]');
      if (source && !source.src) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      }

      video.load();

      if (!prefersReducedMotion() && video.dataset.fsVideoAutoplay === 'true') {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      }

      video.dataset.fsVideoLoaded = 'true';
    };

    const observeVideo = (video, observer) => {
      if (!supportsIntersectionObserver || designMode) {
        loadVideoSource(video);
        return;
      }

      observer.observe(video);
    };

    let observer;
    if (supportsIntersectionObserver) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }

            loadVideoSource(entry.target);
            observer.unobserve(entry.target);
          });
        },
        {
          rootMargin: '200px 0px',
          threshold: 0.01,
        }
      );
    }

    videos.forEach((video) => observeVideo(video, observer));

    desktopMediaQuery.addEventListener('change', (event) => {
      if (!event.matches) {
        return;
      }

      videos.forEach((video) => {
        if (video.dataset.fsVideoLoaded === 'true') {
          return;
        }

        loadVideoSource(video);
      });
    });

    const handleMotionPreferenceChange = (event) => {
      if (!event.matches) {
        videos.forEach((video) => {
          if (video.dataset.fsVideoLoaded === 'true') {
            return;
          }
          loadVideoSource(video);
        });
        return;
      }

      videos.forEach((video) => {
        if (!video.paused) {
          video.pause();
        }
      });
    };

    if (typeof prefersReducedMotionQuery.addEventListener === 'function') {
      prefersReducedMotionQuery.addEventListener('change', handleMotionPreferenceChange);
    } else if (typeof prefersReducedMotionQuery.addListener === 'function') {
      prefersReducedMotionQuery.addListener(handleMotionPreferenceChange);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
